<template>
  <v-app>
			<transition name="fade" mode="out-in">
				<router-view/>
			</transition>
			<Footer v-if="collectionFound"/>
  </v-app>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	export default {
		name: 'App',
		components: {
			Footer: () => import('@/components/FooterComponent'),
		},
		mounted(){

		},
		data: () => ({}),
		computed: {
			...mapState(['collectionFound','alert']),
		}
	};
</script>
